import React from 'react';
import PropTypes from 'utils/propTypes';
import classNames from 'classnames';
import userImage from 'assets/img/users/100_4.jpg';
import {canUseWebP} from "../utils/Utilities";

const Avatar = ({
  rounded,
  circle,
  src,
  size,
  tag: Tag,
  className,
  style,
  ...restProps
}) => {
  const classes = classNames({ 'rounded-circle': circle, rounded }, className);
  if(src && src.includes("base64")){
    // Base 64 nothing to do
  }else{
    if(canUseWebP()){
      src = src+"?webp=true"
    }else{
      src = src+"?webp=false"
    }
  }

  return (
    <Tag
      src={src}
      style={{ width: size, height: size, ...style }}
      className={classes}
      {...restProps}
    />
  );
};

Avatar.propTypes = {
  tag: PropTypes.component,
  rounded: PropTypes.bool,
  circle: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  src: PropTypes.string,
  style: PropTypes.object,
};

Avatar.defaultProps = {
  tag: 'img',
  rounded: false,
  circle: true,
  size: 40,
  src: userImage,
  style: {},
};

export default Avatar;
